import { isLocal } from '../../constants/envs';

export const detectUrlParams = () => {
  const params = window.location.search;
  isLocal && console.log('[urlParams]', { params });
  const urlParams = new URLSearchParams(params);
  const isHiveOnlyLogin = urlParams.has('hive');
  if (isHiveOnlyLogin) {
    sessionStorage.setItem('exclusiveLogin', 'hive');
    return;
  }
  const isWaxOnlyLogin = urlParams.has('wax') || urlParams.has('waxp');
  if (isWaxOnlyLogin) {
    sessionStorage.setItem('exclusiveLogin', 'wax');
    return;
  }
  const isBtcOnlyLogin = urlParams.has('btc') || urlParams.has('bitcoin');
  if (isBtcOnlyLogin) {
    sessionStorage.setItem('exclusiveLogin', 'btc');
    return;
  }
  const isEthOnlyLogin = urlParams.has('eth') || urlParams.has('ethereum');
  if (isEthOnlyLogin) {
    sessionStorage.setItem('exclusiveLogin', 'eth');
    return;
  }
  const isSklOnlyLogin = urlParams.has('skl') || urlParams.has('skale');
  if (isSklOnlyLogin) {
    sessionStorage.setItem('exclusiveLogin', 'skl');
    return;
  }
  sessionStorage.removeItem('exclusiveLogin');
};

export const getSingleChainLogin = () => {
  return sessionStorage.getItem('exclusiveLogin');
};
